const CLIENT_ID = process.env.REACT_APP_YAHOO_CLIENT_ID;
const REDIRECT_URI = process.env.REACT_APP_YAHOO_REDIRECT_URI;
const HARAMBOT_API_URL = process.env.REACT_APP_HARAMBOT_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

export const yahooService = {
  getOAuthUrl: (state?: string) => {
    const params: any = {
      client_id: CLIENT_ID || '',
      redirect_uri: REDIRECT_URI || '',
      response_type: 'code',
    };
    if (state) {
      params.state = state;
    }
    const searchParams = new URLSearchParams(params);
    return `https://api.login.yahoo.com/oauth2/request_auth?${searchParams.toString()}`;
  },

  exchangeCodeForToken: async (code: string, guildId?: string | null): Promise<{ access_token: string, refresh_token: string }> => {
    const response = await fetch(`${HARAMBOT_API_URL}/auth/callback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': API_KEY || '',
      },
      body: JSON.stringify({ 
        code,
        guild_id: guildId,
        provider: 'yahoo'
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to exchange Yahoo authorization code for token');
    }

    return await response.json();
  },
};
